export default __webpack_public_path__ + "cb8ea2e88a79e67318db0d829607b66d.png";